import React, { useEffect } from "react";
import api from "../../config/api";
import getRequestConfig from "../../utils/getRequestConfig";
const Home = () => {
 
  return <h3>Employee home</h3>;
};
export default Home;
